module.exports = __webpack_public_path__ + "static/img/sqrcode.ee2dc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sqrcode.png
// module id = VB/E
// module chunks = 58